<template>
  <section class="mission-section animate-up delay-3">
    <div class="container">
      <div class="mission-box">
        <h2>My Mission</h2>
        <p>
          "To empower my clients through education and expert representation,
          ensuring they make the most informed decisions in the ever-changing
          Greater Chandigarh area real estate market."
        </p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.mission-section {
  padding: 60px 0 100px;
}
.mission-box {
  background: #111;
  color: white;
  padding: 60px;
  border-radius: 12px;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
}
.mission-box h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #b91c1c;
}
.mission-box p {
  font-size: 1.4rem;
  font-style: italic;
  line-height: 1.6;
  opacity: 0.9;
}
</style>
